
/**
 * 通用API服务，用于简单的调用后端的Controller及其方法，避免后端人员自行处理Restful类型API的麻烦
 */
export class API {
    url: string;
/**
 * 注入http服务
 * @param {...?} args
 * @return {?}
 */
call(...args: any[]): any { };
/**
 *  get请求
 * @param {?} url
 * @param {?} paramObj
 * @return {?}
 */
get(url, paramObj) { };
/**
 * @param {?} obj
 * @return {?}
 */
toQueryString(obj: any): any { };
/**
 * @param {?} key
 * @param {?} value
 * @return {?}
 */
toQueryPair(key: any, value: any): any { };
}

function API_tsickle_Closure_declarations() {
/** @type {?} */
API.prototype.url;
}

